export function map<T, R>(value: Exclude<T, null | undefined>, handler: (value: T) => R): R;
export function map<T, R>(value: T | null | undefined, handler: (value: T) => R): R | undefined;
export function map<T, R>(value: T | null | undefined, handler: (value: T) => R): R | undefined {
  if (value == null) return undefined;
  return handler(value);
}
